import CollectionList from 'components/CollectionList/CollectionList'
import CollectionHeader from 'components/shared/CollectionHeader/CollectionHeader'
import Footer from 'components/shared/Footer/Footer'
import HtmlHead from 'components/shared/HtmlHead/HtmlHead'
import Loader from 'components/shared/Loader/Loader'
import NoMatch from 'components/shared/NoMatch/NoMatch'
import SiteHeader from 'components/shared/SiteHeader/SiteHeader'
import { themeClassName } from 'helpers/Project'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { withNamespaces } from 'react-i18next'
import { connect } from 'react-redux'
import { fetchCollections } from 'redux/actions/CollectionActions'

const CollectionListContainer = ({
  t,
  tReady,
  collections,
  fetchCollectionsAction,
  i18n,
}) => {
  const [shouldRender, setShouldRender] = useState(false)
  const { entities = {}, error, loading } = collections

  useEffect(() => {
    fetchCollectionsAction(i18n.language)
  }, [fetchCollectionsAction, i18n.language])

  useEffect(() => {
    setShouldRender(true)
  }, [])

  return (
    <>
      <HtmlHead
        title={t('meta.collection.title')}
        description={t('meta.collection.description')}
      />
      <SiteHeader locale={i18n.language} />
      <NoMatch error={error} />
      <Loader display={loading || !tReady} />
      {shouldRender &&
        !loading &&
        tReady &&
        Object.keys(entities).length !== 0 && (
          <div className={`c-collection-container ${themeClassName('cyan')}`}>
            <CollectionHeader
              title={t('meta.collection.title')}
              subtitle={t('meta.collection.subtitle')}
              imageLeft={false}
            />
            <CollectionList />
          </div>
        )}
      {shouldRender && !loading && tReady && (
        <Footer
          text="project.footer.feedback.homepage.text"
          userID="collection-list-footer-user-id"
        />
      )}
    </>
  )
}

CollectionListContainer.propTypes = {
  t: PropTypes.func.isRequired,
  tReady: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    language: PropTypes.string.isRequired,
  }).isRequired,
  collections: PropTypes.object.isRequired,
  fetchCollectionsAction: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCollectionsAction: (locale) => dispatch(fetchCollections(locale)),
  }
}

const mapStateToProps = ({ collections = {} }) => {
  return { collections }
}

export { CollectionListContainer }
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces('translations')(CollectionListContainer))
